/* Judge.me review-photo fallback.
   When a review has no customer photo, inject the product image instead.
   Watches for async-rendered Judge.me widgets via MutationObserver. */
(() => {
  // The product image to use as fallback on this page.
  // On product pages: og:image is set by Shopify to the main product photo.
  // On homepage carousel cards: each review links to a product — we read the
  // product handle from the link href and use a thumbnail URL.
  const getProductImage = () => {
    const og = document.querySelector('meta[property="og:image"]');
    return og ? og.content : null;
  };

  const productImg = getProductImage();

  const photoFor = (reviewEl) => {
    // 1. Product-page widget: just use the og:image
    if (productImg && document.body.classList.contains('template-product')) {
      return productImg;
    }
    // 2. Carousel / aggregate widgets: find the linked product, build a thumbnail URL
    const link = reviewEl.querySelector(
      '.jdgm-rev__product-link, a.jdgm-carousel-item__product-link, a[href*="/products/"]'
    );
    if (link) {
      const href = link.getAttribute('href') || '';
      // If the link already contains an img child, use that
      const linkedImg = link.querySelector('img');
      if (linkedImg && linkedImg.src) return linkedImg.src;
      // Fallback: try Shopify's product.json for a thumbnail
      // (not synchronous — skip if image not in DOM already)
    }
    return null;
  };

  const inject = (reviewEl) => {
    if (reviewEl.dataset.nwFbDone === 'true') return;

    // Does the review already have a customer photo?
    const hasUserPhoto =
      reviewEl.querySelector('.jdgm-rev__pic img, img.jdgm-rev__pic, .jdgm-rev__pic-container img, .jdgm-carousel-item__review-image img') !== null;

    if (hasUserPhoto) {
      reviewEl.dataset.nwFbDone = 'true';
      return;
    }

    const url = photoFor(reviewEl);
    if (!url) return;

    reviewEl.dataset.nwFbDone = 'true';
    reviewEl.classList.add('nw-jdgm-fb');

    const wrap = document.createElement('div');
    wrap.className = 'nw-jdgm-fb__photo';

    const img = document.createElement('img');
    img.src = url;
    img.alt = '';
    img.loading = 'lazy';
    wrap.appendChild(img);

    // Insert at the top of the review card so it sits where a real photo would
    reviewEl.insertBefore(wrap, reviewEl.firstChild);
  };

  const scan = () => {
    document
      .querySelectorAll('.jdgm-rev, .jdgm-carousel-item')
      .forEach(inject);
  };

  // Initial run + observe for async-injected widgets
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes.length) {
        scan();
        return;
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
